import { useLanguage } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLang } = useLanguage();

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <button
        onClick={() => setLang('en')}
        data-testid="lang-switch-en"
        className={`px-2 py-1 text-sm font-medium rounded transition-all ${
          language === 'en'
            ? 'bg-[#1D4E41] text-white'
            : 'text-gray-600 hover:text-[#1D4E41] hover:bg-gray-100'
        }`}
        aria-label="English"
      >
        EN
      </button>
      <span className="text-gray-300">|</span>
      <button
        onClick={() => setLang('es')}
        data-testid="lang-switch-es"
        className={`px-2 py-1 text-sm font-medium rounded transition-all ${
          language === 'es'
            ? 'bg-[#1D4E41] text-white'
            : 'text-gray-600 hover:text-[#1D4E41] hover:bg-gray-100'
        }`}
        aria-label="Español"
      >
        ES
      </button>
    </div>
  );
};

export default LanguageSwitcher;
